export default __webpack_public_path__ + "static/media/helpHistory.6f7d0343.png";